export const ERR_FETCH_BY_OWNER_REQUIRED = 'fetchByOwner is required';
export const ERR_NO_LIGHT_TOKEN_BALANCE_UNWRAP =
    'No light-token balance to unwrap';
export const ERR_MINT_MISSING_MERKLE_CONTEXT =
    'Mint does not have MerkleContext';
export const ERR_MINT_MISSING_TOKEN_METADATA =
    'Mint does not have TokenMetadata extension';
export const ERR_MINT_MISSING_MINT_CONTEXT = 'Mint does not have MintContext';
